module.exports = __webpack_public_path__ + "img/f4-03.194187cb.png";